import { combineEpics } from 'redux-observable';

import { _reducer } from './accountabilityWeight.reducers';
import _epics from './accountabilityWeight.epics';

export const epics = combineEpics(_epics);
export { _reducer };
export * from './accountabilityWeight.actions';
